module.exports = __webpack_public_path__ + "static/img/2.b188221.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/sp/2.png
// module id = mVMy
// module chunks = 0